module.exports = __webpack_public_path__ + "static/img/Jake-Averillo.07993ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jake-Averillo.jpg
// module id = 0kYI
// module chunks = 0